import { render } from "./AccountLogin.vue?vue&type=template&id=51005084&scoped=true"
import script from "./AccountLogin.vue?vue&type=script&lang=js"
export * from "./AccountLogin.vue?vue&type=script&lang=js"

import "./AccountLogin.vue?vue&type=style&index=0&id=51005084&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51005084"]])

export default __exports__